import { Collapse } from 'bootstrap';
import SmoothScroll from 'smooth-scroll';
import Splide from '@splidejs/splide';
import Clients from "../../parts/blocks/clients/js";


(function ($, root, undefined) {
	
	$(function () {
		
		'use strict';
		//console.log('ready');

		var scroll = new SmoothScroll('a[href*="#"]', {
			topOnEmptyHash: true,
			speed: 500,
			speedAsDuration: true,
			offset: 78,
			easing: 'easeInOutQuad',
		});

	});
	

	const burgerMenu = document.getElementById("burger");
		const navbarMenu = document.getElementById("menu");

		// Show and Hide Navbar Menu
		if (burgerMenu) {
			burgerMenu.addEventListener("click", () => {
				burgerMenu.classList.toggle("is-active");
				navbarMenu.classList.toggle("is-active");

				if (navbarMenu.classList.contains("is-active")) {
					navbarMenu.style.maxHeight = navbarMenu.scrollHeight + "px";
				} else {
					navbarMenu.removeAttribute("style");
				}
			});
		}
	

		$('a[data-scroll]').click(function(e) {
            e.preventDefault();

            var offset = 155;
            var target = ( '#' + $(this).data('scroll') );
            var $target = $(target);
            
            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - offset
            }, 800, 'swing');
        }); 
	
})(jQuery, this);